import { render, staticRenderFns } from "./AgeRating06.vue?vue&type=template&id=617c85a2"
import script from "./AgeRating06.vue?vue&type=script&lang=js"
export * from "./AgeRating06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports